module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.FilterAgency()
      }
    }
  }, [_vm._v("Agent Search")]), _vm._v(" "), _c('b-modal', {
    ref: "FilterAgency-modal",
    attrs: {
      "id": "FilterAgency-modal",
      "title": "Filter Agency",
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', [_c('h5', [_vm._v("Filter Agency")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-input', {
    staticClass: "mb-2 w-100",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    on: {
      "keyup": function($event) {
        _vm.AgencyFilterFunct(true)
      }
    },
    model: {
      value: (_vm.filterAgent),
      callback: function($$v) {
        _vm.filterAgent = $$v
      },
      expression: "filterAgent"
    }
  })], 1), _vm._v(" "), (_vm.ismodalLoding) ? _c('CustommodelLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-button', {
    on: {
      "click": function($event) {
        _vm.AgencyFilterFunct(false)
      }
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table mb-0 table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Category Type")]), _vm._v(" "), _c('th', [_vm._v("Agent Name")]), _vm._v(" "), _c('th', [_vm._v("Company Details")]), _vm._v(" "), _c('th', [_vm._v("Contact Details")]), _vm._v(" "), _c('th', [_vm._v("Country Name")]), _vm._v(" "), _c('th', [_vm._v("\n                Engagement Preference "), _c('br'), _vm._v("\n                Status\n              ")])])]), _vm._v(" "), (_vm.allAgentColoaderData.length > 0) ? _c('tbody', _vm._l((_vm.allAgentColoaderData), function(agent_item, agent_index) {
    return _c('tr', {
      key: agent_index
    }, [_c('td', [_vm._v(_vm._s(agent_index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agent_item.categoryType))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(agent_item.agentName != "" ? agent_item.agentName : "--") + "\n              ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Company Name : " + _vm._s(agent_item.companyName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Address : " + _vm._s(agent_item.address)), _c('br')])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Contact No. : " + _vm._s(agent_item.contactNumber)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Email : " + _vm._s(agent_item.emailId)), _c('br')])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(agent_item.countryName)), _c('br')])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(agent_item.engagementPreference)), _c('br')]), _vm._v(" "), _c('b-badge', [_vm._v(_vm._s(agent_item.isACActive == 1 ? "Active" : "In-Active"))])], 1)])
  })) : _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_c('center', [_vm._v("Data Not Found")])], 1)])])])])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideFilterAgency
    }
  }, [_vm._v("\n      Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61224bb0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/filterAgencyModal.vue
// module id = 2678
// module chunks = 0